import { render, staticRenderFns } from "./PayslipAndTaxcardDesign.vue?vue&type=template&id=6b452ba3&scoped=true"
import script from "./PayslipAndTaxcardDesign.vue?vue&type=script&lang=js"
export * from "./PayslipAndTaxcardDesign.vue?vue&type=script&lang=js"
import style0 from "./PayslipAndTaxcardDesign.vue?vue&type=style&index=0&id=6b452ba3&prod&scoped=true&lang=css"
import style1 from "./PayslipAndTaxcardDesign.vue?vue&type=style&index=1&id=6b452ba3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b452ba3",
  null
  
)

export default component.exports